import Vue from 'vue';
import { capitalize } from '@/utils/text';

Vue.filter('capitalize', (value?: string | null) => {
  return capitalize(value);
});
